import moment from "moment";

export default {
  state: {
    crawltodo: [],
    total: 0,
    page: 1,
  },

  getters: {
    crawltodo: (state) => {
      return state.crawltodo
    },
    crawltodoTotal: (state) => {
      return state.total
    },
  },

  actions: {
    getCrawlTodo({ commit }, { $api, limit, page }) {
      $api.get(`podcasts/crawl/todo?limit=${limit ? limit : 20}&page=${page ? page : 0}`)
        .then((response) => {
          response.data.items.map((c) => {
            c.date_next_crawl = moment(c.date_next_crawl).format()
            c.date_last_published = moment(c.date_last_published).format()
            c.date_checked = moment(c.date_checked).format()
            return c
          })
          commit('setCrawlTodo', response.data)
        })
    },

  },

  mutations: {
    setCrawlTodo(state, data) {
      state.crawltodo = data.items
      state.total = data.total
      state.page = data.page
    },
  }
}
